var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterinline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 29.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M32.27,7.31a4,4,0,0,1,.07.92,20.61,20.61,0,0,1-1.4,7.41,23,23,0,0,1-4,6.75,18.84,18.84,0,0,1-6.64,5,21,21,0,0,1-9,1.9A20.51,20.51,0,0,1,0,26c.52,0,1.1.07,1.76.07A14.64,14.64,0,0,0,11,22.85a6.91,6.91,0,0,1-4.33-1.44,7.36,7.36,0,0,1-2.56-3.62,12.5,12.5,0,0,0,1.33.07,9.35,9.35,0,0,0,2-.21,7.18,7.18,0,0,1-3-1.41,7.79,7.79,0,0,1-2.11-2.56,7,7,0,0,1-.77-3.27v-.14a7,7,0,0,0,3.3,1,7.1,7.1,0,0,1-3.3-6.19,7.13,7.13,0,0,1,1-3.72A20.46,20.46,0,0,0,9.25,6.82a20.37,20.37,0,0,0,8.47,2.25,9.56,9.56,0,0,1-.14-1.69,7.15,7.15,0,0,1,2.14-5.2A7,7,0,0,1,24.89,0,7.1,7.1,0,0,1,30.3,2.32,15,15,0,0,0,35,.56a7.35,7.35,0,0,1-3.24,4.08A16.31,16.31,0,0,0,36,3.45,16.09,16.09,0,0,1,32.27,7.31Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterinline);
export default __webpack_public_path__ + "static/media/twitter.inline.b521d8ba54e963630c6a9e0e935d3cac.svg";
export { ForwardRef as ReactComponent };